import { render, staticRenderFns } from "./TikTokVideos.vue?vue&type=template&id=1e7bf9ce&scoped=true&lang=pug&"
import script from "./TikTokVideos.vue?vue&type=script&lang=js&"
export * from "./TikTokVideos.vue?vue&type=script&lang=js&"
import style0 from "./TikTokVideos.vue?vue&type=style&index=0&id=1e7bf9ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7bf9ce",
  null
  
)

export default component.exports